// Starter: a personalised PDF + a 15-minute call with Madhulika, for a small ₹9 token.
// PLACEHOLDER: set REACT_APP_STARTER_URL to the Topmate checkout link once it exists.
// Until then the form hands visitors to a pre-filled WhatsApp chat, so their details still reach Madhulika.
const WHATSAPP_NUMBER = '919868911575';

export const STARTER = {
  price: '₹9',
  duration: '15 min',
  label: 'Experience the difference',
  checkoutUrl: process.env.REACT_APP_STARTER_URL || '',
} as const;

export type Lead = { name: string; whatsapp: string; gender: string; reason: string; intent: string };

/** Where the visitor goes after the form: the checkout if configured, otherwise WhatsApp with their details. */
export function nextStepUrl(lead: Lead, source: string): string {
  if (STARTER.checkoutUrl) {
    const url = new URL(STARTER.checkoutUrl, window.location.origin);
    url.searchParams.set('utm_source', 'website');
    url.searchParams.set('utm_medium', source);
    return url.toString();
  }
  const text = [
    'Hi Madhulika, I would like to begin.',
    `Name: ${lead.name}`,
    `WhatsApp: ${lead.whatsapp}`,
    `Gender: ${lead.gender}`,
    `Here for: ${lead.reason}`,
    ...(lead.intent ? [`Looking for: ${lead.intent}`] : []),
  ].join('\n');
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
}
